import { render, staticRenderFns } from "./sales-planning-list.vue?vue&type=template&id=2bdb62cc"
import script from "./sales-planning-list.vue?vue&type=script&lang=js"
export * from "./sales-planning-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports